import { credentialReducers } from "@p0security/shared/assessment/reducers/credential";
import { isNode } from "@p0security/shared/graph/types";

import { credentialColumns } from "./columns";

export const credentialData = {
  predicate: isNode("credential"),
  reducers: credentialReducers,
  columns: credentialColumns,
};
